import { CORE_PATH } from '@shared/api/paths';

export const MAIN_PATH = 'OsiServices';

export const path = `${CORE_PATH}/${MAIN_PATH}`;
